import * as React from "react";
import { IdResource } from "../../constants/IdResource";
import { IdStyles } from "../../less/IdStyles";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
export var MenuInfoContentTitleRecipe = function (props) {
    var recipeCost = props.cost.find(function (cost) { return cost.typeId !== IdResource.Money; });
    var title = utilLoca.get(recipeCost.locaKey);
    return (React.createElement("div", { className: IdStyles.InfoMenuTitleContainer + " flex flex--guts" },
        React.createElement(FontWithOutline, { style: IdStyles.HeadlineOne }, title)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info-menu/MenuInfoContentTitleRecipe.tsx
// module id = 2842
// module chunks = 3